import Select from "react-select";
import genderList from "../data/gender.json"; 

 

export const renderInputTextField = (fieldName,validationMsg, label, placeholder, val, className,handleChange,validate,errors,checkMsg) => (
    <div className="form-group">
      {/* <label>{label}:</label> */}
      {/* {checkMsg && <p style={{ color: 'red', marginBottom: '0px', paddingBottom: '0px' }}>{checkMsg.name}</p>} */}
      <span className="gs-validation-error-message">{errors[fieldName]}</span> 
        <input
          type="text"
          name={fieldName}
          value={val}
          onChange={handleChange}
          onBlur={validate}
          className={className}
          placeholder={placeholder}
          alt={validationMsg}
          // required={true}
          maxLength={"40"}
        />
         
             {/* <span className="gs-validation-error-message">
             {Object.entries(errors).map(([key, value]) => (
             value
            )
            )}

        
             </span> */}

             {/* {
             errors.map((err) => (
              <span className="gs-validation-error-message">{err}</span> 
             ))
            } */}

             {/* {
               Object.entries(errors).map(([key, value]) => (
                <span className="gs-validation-error-message">{value}</span>
               )
               )

             } */}
       {/* {
       errors.name && errors.name.includes(fieldName) ? 
        <span className="gs-validation-error-message">{errors.name}</span>
        : ""
        } */}
    </div>
  );

  // export const handleValidate = (e) => {
  //    const { name, value } = e.target;
  //    if(value ==""){
  //    return handleError(name+ ' Fileds cannot be emplty')
  //    }else{
  //     return "";
  //    }
  // }
  //  function handleError(error){
  //   if(error !=null){
  //     alert(error);
  //     return error;
  //   }
  //    return "";
  //   }
  // export const validateInputField = (e) => {
  //   // alert(e);
  //   // const { name, value } = e.target;
  //   // if (!val) {
  //   //   alert('dd');
  //   // }
  // }

  export const renderGenderDropdownField = (fieldName, label, val, handleChange,onBlur,errors) => (
    <div className="form-group">
      <label>{label}:</label>
      <select name={fieldName} value={val} onChange={handleChange}>
        {genderList.map((gender) => (
         <option key={gender.value} value={gender.value}>{gender.value}</option>
        ))}
     </select>
      <span className="gs-validation-error-message">{errors[fieldName]}</span> 
     {/* {
       errors.fieldName && errors.fieldName.includes(fieldName) ? 
        <span className="error-message">{errors.fieldName}</span>
        : ""
        } */}
    </div>
  );

  export const renderGradeDropdownMultiSelectField = (fieldName, label, val, handleChange,onBlur,errors) => (
    <div className="form-group">
        <label>Grade</label>
        <Select
            isMulti
            closeMenuOnSelect={false}
            onChange={handleChange}
            name={fieldName}
            options={val} />
       <span className="gs-validation-error-message">{errors[fieldName]}</span> 
      {/* {
       errors.fieldName && errors.fieldName.includes(fieldName) ? 
        <span className="error-message">{errors.fieldName}</span>
        : ""
        } */}
    </div>
  );

  export const renderDropdownFieldFromDBObj = (fieldName, label, val, dataList, handleChange,onBlur,errors) => (
    <div className="form-group">
      <label>{label}:</label>
      <select 
      name={fieldName} 
      value={val} 
      onChange={handleChange}
      onBlur={onBlur}
      >
      <option value="">Select {fieldName}</option>
      {fieldName === 'schoolName' ?  
      dataList.map((obj,index) => (
        <option key={index} value={obj.id}>{obj.name}</option>
        ))
       :
       fieldName === 'role' ?  
            dataList.map((obj,index) => (
              <option key={index} value={obj.roleName}>{obj.roleName}</option>
              ))
              :
             fieldName === 'admissionYear' ?  
            dataList.map((obj,index) => (
              <option key={index} value={obj.value}>{obj.value}</option>
              ))
              :
              fieldName === 'siteContentTemplate' ?  
               dataList.map((obj,index) => (
              <option key={index} value={obj.value}>{obj.value}</option>
              ))
              : 
              ""
        }
     </select>
      <span className="gs-validation-error-message">{errors[fieldName]}</span> 
     {/* {
       errors.fieldName && errors.fieldName.includes(fieldName) ? 
        <span className="error-message">{errors.fieldName}</span>
        : ""
        } */}
        {/* {errors.fetchError && <span className="error-message">{errors.fetchError}</span>} */}
    </div>

  );

  export const renderDropdownFieldFromDBList = (fieldName, validationMsg,label, val, dataList,classNameHolder, handleChange,onBlur,errors) => (
    <div className="form-group">
      {/* <label>{label}:</label> */}
      <select 
      name={fieldName} 
      value={val} 
      className={classNameHolder}
      alt={validationMsg}
      onChange={handleChange}>
      onBlur={onBlur}
      <option value="">Select</option>
      {dataList.map((obj,index) => (
        <option key={index} value={obj}>{obj}</option>
        ))}
     </select>
    <span className="gs-validation-error-message">{errors[fieldName]}</span> 
     {/* {
       errors.fieldName && errors.fieldName.includes(fieldName) ? 
        <span className="error-message">{errors.fieldName}</span>
        : ""
        } */}
        {/* {errors.fetchError && <span className="error-message">{errors.fetchError}</span>} */}
    </div>

  );

  export const renderTextArea = (fieldName,validationMsg, label, placeholder,val,className, handleChange,onBlur,errors) => (
    <div className="form-group">
        {/* <label>{label}:</label> */}
        <textarea
            name={fieldName}
            className={className}
            value={val}
            alt={validationMsg}
            onChange={handleChange}
            placeholder={placeholder}
            onBlur={onBlur}
            rows="3"
        />
           <span className="gs-validation-error-message">{errors[fieldName]}</span> 
      {/* {
       errors.fieldName && errors.fieldName.includes(fieldName) ? 
        <span className="error-message">{errors.fieldName}</span>
        : ""
        } */}
</div>
  );


    export const renderNumberField = (fieldName, label, placeholder,val, handleChange,onBlur,errors) => (
        <div className="form-group">
        <label>{label}:</label>
            <input
            type="number"
            name={fieldName}
            value={val}
            onChange={handleChange}
            placeholder={placeholder}
            onBlur={onBlur} 
            />
             <span className="gs-validation-error-message">{errors[fieldName]}</span> 
            {/* {
       errors.fieldName && errors.fieldName.includes(fieldName) ? 
        <span className="error-message">{errors.fieldName}</span>
        : ""
        } */}
        </div>
    );

    export const renderEmailField = (fieldName, label, placeholder,val, handleChange,onBlur,errors,checkMsg) => (
        <div className="form-group">
            <label>{label}:</label>
            {checkMsg && <p style={{ color: 'red', marginBottom: '0px', paddingBottom: '0px' }}>{`${checkMsg}`}</p>}
            <input 
            type="email" 
            name={fieldName} 
            value={val} 
            onChange={handleChange} 
            onBlur={onBlur} 
            placeholder={placeholder} 
            />
           <span className="gs-validation-error-message">{errors[fieldName]}</span> 
{/* <span className="gs-validation-error-message">
             {Object.entries(errors).map(([key, value]) => (
             value
            )
            )} 
         </span>    */}
            {/* <span className="gs-validation-error-message">{errors}</span> */}
             {/* {
            errors.email && errors.email.includes(fieldName) ? 
              <span className="gs-validation-error-message">{errors.email}</span>
              : ""
            } */}
        </div>
    );

    export const renderDateField = (fieldName, label,val, handleChange,onBlur,errors) => (
    <div className="form-group">
        <label htmlFor="dob">{label}:</label>
        <input
        type="date"
        id={fieldName}
        name={fieldName}    
        value={val}   
        onChange={handleChange}
        onBlur={onBlur} 
         />
        <span className="gs-validation-error-message">{errors[fieldName]}</span> 

    </div>
    );

   
    